import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { CapNames } from '../CapNames';
import { Orientation } from '../Orientation';
import { Materials } from '../../materials/Materials';
/**
 * Capability to draw OBJ Files
 */
export class FileObjCap {
    getName() {
        return CapNames.OBJFILE;
    }
    // tslint:disable:no-console
    call(objectIn, sceneIn) {
        const { payload } = objectIn;
        if (!!payload && !!payload.objFile) {
            const mtlLoader = new MTLLoader();
            mtlLoader.setPath(payload.baseUrl);
            // @ts-ignore
            mtlLoader.setResourcePath(payload.baseUrl);
            if (payload.mtlFile) {
                mtlLoader.load(payload.mtlFile, (materials) => {
                    const setter = materials ? (objLoader) => {
                        materials.preload();
                        objLoader.setMaterials(materials);
                    } : undefined;
                    this._loadObj(payload, setter, objectIn, sceneIn);
                }, undefined, (error) => {
                    console.error('Unable to load Mtl file:' + error);
                });
            }
            else {
                this._loadObj(payload, undefined, objectIn, sceneIn);
            }
            return true;
        }
        return false;
    }
    _loadObj(payload, materialSetter, objectIn, sceneIn) {
        const objLoader = new OBJLoader();
        if (materialSetter) {
            materialSetter(objLoader);
        }
        objLoader.setPath(payload.baseUrl);
        objLoader.load(payload.objFile, (obj) => {
            obj.name = objectIn.name;
            Orientation.set(obj, objectIn);
            if (payload.mtlFile == null && objectIn.materials !== undefined) {
                const mod = objectIn.materials.length;
                obj.children.forEach((o, i) => {
                    o.material = Materials.create(objectIn.materials[i % mod]);
                });
            }
            sceneIn.add(obj);
        }, undefined, (error) => {
            console.error('Unable to load Obj file:' + error);
        });
    }
}
//# sourceMappingURL=FileObjCap.js.map